/* Code generated with AutoHTML Plugin for Figma */
import { useContext } from "react";
import { PublicContext } from "../../Contexts/PublicContext";
import ImageExecutor from "../../assets/images/f_1.png";
import ImageClient from "../../assets/images/f_c_1.png";

import {
  _colorText,
  _size,
  _sizeHeading,
  _style,
  url_android_app,
  url_telegram_ispolnitel,
} from "../../core/core";
import { ButtonTheme } from "../ButtonTheme/ButtonThemen";
import { Link } from "../link/link";
import Title from "../texts/title";
import "./Footer.css";

export const Footer = ({ ...props }) => {
  const { isClient } = useContext(PublicContext);

  const is_mob_footer = window.innerWidth < 988;
  const get_links_mob = () => {
    if (!isClient) {
      return (
        <div className="footer-mob-links">
          <div className="footer-mob-links-row">
            <Link style={_style.outline} size={_size.M} link={url_android_app}>
              ПРИЛОЖЕНИЕ НА ANDROID 🔥
            </Link>
          </div>
          <div className="footer-mob-links-row">
            <Link
              style={_style.outline}
              size={_size.M}
              link={"mailto:ISPOLNITEL@viw.im"}
            >
              ISPOLNITEL@VIW.IM
            </Link>
          </div>
          <div className="footer-mob-links-row">
            <Link
              style={_style.outline}
              link={url_telegram_ispolnitel}
              size={_size.M}
            >
              Сообщество
            </Link>
            <ButtonTheme size={_size.M} style={_style.outline} />
          </div>
        </div>
      );
    } else {
      return (
        <div className="footer-mob-links">
          <div className="footer-mob-links-row">
            <Link
              style={_style.outline}
              link={"mailto:support@viw.im"}
              size={_size.M}
            >
              SUPPORT@VIW.IM
            </Link>
          </div>
          <div className="footer-mob-links-row">
            <Link
              style={_style.outline}
              link={url_telegram_ispolnitel}
              size={_size.M}
            >
              Сообщество
            </Link>
            <ButtonTheme size={_size.M} style={_style.outline} />
          </div>
        </div>
      );
    }
  };
  const get_image = () => {
    if (!isClient) {
      return <img className="cone-01-2" src={ImageExecutor} />;
    } else return <img className="cone-01-2" src={ImageClient} />;
  };

  const get_links_desk = () => {
    if (!isClient) {
      return (
        <div className="footer-body-right">
          <div className="footer-body-right-row">
            <Link
              style={_style.outline}
              size={_size.M}
              link={"mailto:ISPOLNITEL@viw.im"}
            >
              ISPOLNITEL@VIW.IM
            </Link>
          </div>
          <div className="footer-body-right-row">
            <Link
              style={_style.outline}
              link={url_telegram_ispolnitel}
              size={_size.M}
            >
              Сообщество
            </Link>
            <ButtonTheme size={_size.M} style={_style.outline} />
          </div>
          <div className="footer-body-right-row">
            <Link style={_style.outline} link={url_android_app} size={_size.M}>
              ПРИЛОЖЕНИЕ НА ANDROID 🔥
            </Link>
          </div>
        </div>
      );
    } else {
      return (
        <div className="footer-body-right">
          <div className="footer-body-right-row">
            <Link
              style={_style.outline}
              link={url_telegram_ispolnitel}
              size={_size.M}
            >
              Сообщество
            </Link>
            <Link
              style={_style.outline}
              link={"mailto:support@viw.im"}
              size={_size.M}
            >
              SUPPORT@VIW.IM
            </Link>
          </div>
          <div className="footer-body-right-row">
            <ButtonTheme size={_size.M} style={_style.outline} />
          </div>
        </div>
      );
    }
  };

  const get_pages_desk = () => {
    if (!isClient) {
      return (
        <div className="footer-body-left">
          <Link link={"/ispolniteli/zadaniya/"} style={_style.clear}>
            ЗАДАНИЯ
          </Link>
          <Link link={"/ispolniteli/top/"} style={_style.clear}>
            ТОП ИСПОЛНИТЕЛЕЙ🔥
          </Link>
          <Link link={"/ispolniteli/"} style={_style.clear}>
            ЗАКАЗЧИКУ
          </Link>
          <Link link={"/about/?client=false"} style={_style.clear}>
            О ПЛАТФОРМЕ
          </Link>
          {/* <Link style={_style.clear}>БЛОГ</Link> */}
        </div>
      );
    } else {
      return (
        <div className="footer-body-left">
          <Link link={"/uslugi/"} style={_style.clear}>
            УСЛУГИ
          </Link>
          <Link link={"/"} style={_style.clear}>
            ИСПОЛНИТЕЛЮ
          </Link>
          <Link link={"/about/?client=true"} style={_style.clear}>
            О VIWORK
          </Link>
          {/* <Link style={_style.clear}>БЛОГ</Link> */}
        </div>
      );
    }
  };
  const get_pages_mob = () => {
    if (!isClient) {
      return (
        <div className="footer-mob-pages">
          <div className="footer-mob-pages-column">
            <Link link={"/ispolniteli/zadaniya/"} style={_style.clear}>
              ЗАДАНИЯ{" "}
            </Link>
            <Link link={"/"} style={_style.clear}>
              ЗАКАЗЧИКУ
            </Link>
          </div>
          <div className="footer-mob-pages-column">
            <Link link={"/about/?client=false"} style={_style.clear}>
              О ПЛАТФОРМЕ{" "}
            </Link>
            {/* <Link style={_style.clear}>БЛОГ</Link> */}
          </div>
        </div>
      );
    } else {
      return (
        <div className="footer-mob-pages">
          <div className="footer-mob-pages-column">
            <Link link={"/uslugi/"} style={_style.clear}>
              УСЛУГИ{" "}
            </Link>
            <Link link={"/ispolniteli/"} style={_style.clear}>
              ИСПОЛНИТЕЛЮ{" "}
            </Link>
          </div>
          <div className="footer-mob-pages-column">
            {/* <Link style={_style.clear}>БЛОГ </Link> */}
            <Link link={"/about/?client=true"} style={_style.clear}>
              О ПЛАТФОРМЕ{" "}
            </Link>
          </div>
        </div>
      );
    }
  };
  const get_down_links = () => {
    return (
      <>
        <Link link={"/sitemap.xml"} blank style={_style.neutral}>
          Карта сайта
        </Link>
        <Link link={"/documents/offerta/"} blank style={_style.neutral}>
          Публичная оферта
        </Link>
        <Link link={"/documents/policy/"} blank style={_style.neutral}>
          Политика обработки персональных данных
        </Link>
        <Link style={_style.neutral}>©VIW.im Все права защищены 2024</Link>
        <Link style={_style.neutral} blank link={`/about/?client=${isClient}`}>
          ИП Власов Виталий Владимирович ИНН: 752903513223
        </Link>
        <Link style={_style.neutral} blank link={`/about/?client=${isClient}`}>
          Соправождение и разработка ООО “ВИ”
        </Link>
      </>
    );
  };
  return (
    <div className={"footer"}>
      {is_mob_footer ? (
        <>
          <div className="footer mob-footer-client">
            <a href={isClient ? "/" : "/ispolniteli/"}>
              <Title
                type={_sizeHeading.h1}
                color={_colorText.black}
                is_first_type={false}
              >
                VIWORK
              </Title>{" "}
            </a>

            <div className="footer-cone">{get_image()}</div>
            {get_links_mob()}
            {get_pages_mob()}

            <div className="footer-mob-down">{get_down_links()}</div>
          </div>
        </>
      ) : (
        <>
          <div className="footer footer-executor">
            <div className="footer-cone">{get_image()}</div>
            <div className="footer-body">
              {get_pages_desk()}
              <div className="footer-body-center">
                <a href={isClient ? "/" : "/ispolniteli/"}>
                  <Title
                    type={_sizeHeading.h1}
                    color={_colorText.black}
                    is_first_type={false}
                  >
                    VIWORK
                  </Title>{" "}
                </a>
              </div>
              {get_links_desk()}
            </div>
            <div className="footer-down">{get_down_links()}</div>
          </div>
        </>
      )}
    </div>
  );
};
